<script>
import {getStatusVariants} from "@/utils/statusVariants";
export default {
  name: "status-badge",
  props: {
    entity: {
      type: String,
      required: true,
      validator: value => ['odoo_purchase_order', 'odoo_sale_order', 'odoo_account_move', 'user', "approval_template"].includes(value)
    },
    type: {
      type: String,
      required: true,
      validator: value => ['status', 'invoice_status',].includes(value)
    },
    status: {
      type: String,
      require: true,
    }
  },
  computed: {
    statusVariant() {
      return getStatusVariants(this.entity, this.type, this.status)
    }
  }
}
</script>

<template>
  <span :class="`badge ${statusVariant.class}`">
    <slot>
      {{ $t(statusVariant.label_key) }}
    </slot>
  </span>
</template>

<style scoped lang="scss">
//::v-deep {

.badge {
  border-radius: 4px !important;
  padding: 4px !important;
  font-size: 12px;

  &.bg-primary {
    background-color: #E8F0FF !important;
    color: #1664D8 !important;
  }
  &.bg-success {
    background-color: #DCFCE7 !important;
    color: #15803D !important;
  }
  &.bg-success-custom {
    background-color:#28a745 !important;
    color: #FFFFFF !important;
  }
  &.bg-warning {
    background-color: #FEF0C7 !important;
    color: #DC6803 !important;
  }
  &.bg-danger {
    background-color: #FEE2E2 !important;
    color: #DC2626 !important;
  }
}

</style>